import { createSlice } from '@reduxjs/toolkit';

import type { CoturnCredentials } from '@/types/organization/CoturnCredentials';
import { getCoturnCredentialsThunk } from '@/store/thunks/organization/getCoturnCredentialsThunk';

interface OrganizationState {
  coturnCredentials: CoturnCredentials | null;
  coturnCredentialsLoadedAt: number | null;
  loading: boolean;
  error: string | null;
}

const initialState: OrganizationState = {
  coturnCredentials: null,
  coturnCredentialsLoadedAt: null,
  loading: false,
  error: null
};

export const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    clearCoturnCredentials(state) {
      state.coturnCredentials = null;
      state.coturnCredentialsLoadedAt = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCoturnCredentialsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCoturnCredentialsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.coturnCredentials = action.payload;
        state.coturnCredentialsLoadedAt = Date.now();
      })
      .addCase(getCoturnCredentialsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'Failed to fetch TURN credentials';
      });
  }
});

export const { clearCoturnCredentials } = organizationSlice.actions;
export default organizationSlice.reducer;
